import { BaseInsuranceStatus } from '@/classes/SubmissionStatuses/BaseInsuranceStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class ErrorStatus extends BaseInsuranceStatus {
	getStatusText() {
		return 'Error'
	}

	getToolTipText() {
		return {
			title: 'Submission Error',
			body: 'There was an error when submitting this packet. Click Retry to resubmit. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
